const setHomeContent = (content) => {
	return { content: content, type: 'SET_HOME_CONTENT' };
};

const data = {
	setHomeContent,
};
export default data;
